<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-input
          v-model="searchParam.keyword_search"
          placeholder="请输入关键词搜索"
          clearable
          @clear="getList"
        ></el-input>
        <el-select v-model="searchParam.certificate_uuid" placeholder="证书筛选" clearable @clear="getList">
          <el-option v-for="item in cList" :value="item.uuid" :label="item.title"></el-option>
        </el-select>
        <el-select v-model="searchParam.schoole_uuid" placeholder="分校筛选" clearable @clear="getList">
          <el-option v-for="item in schooleList" :value="item.uuid" :label="item.title"></el-option>
        </el-select>
        <areaSelect
          v-model="searchParam.area"
          clearable
          @province="searchParam.province = $event"
          @city="searchParam.city = $event"
          @clear="getList"
        ></areaSelect>
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="resetSearchP">重置</el-button>
      </div>
    </div>
    <div class="search-bar flex">
      <div class="left" >
        <a
          href="https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/buwandao/static/mini/ccf236f18d63eefe6802a4aecd6006d5.xlsx"
          type="primary"
          target="_blank"
          >导入模板下载</a
        >
        <el-button type="primary" @click="exportStu">导出</el-button>
        <el-button :loading="uping" style="margin-left: 20px" type="primary" @click="clickInp">导入</el-button>
        <input v-show="false" v-if="!uping" id="fileup" type="file" name="" value="" @change="getFile" />
        <el-button type="primary" @click="addStudent">新增学员</el-button>
        <el-button @click="exportLearn">学习进度导出</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="archive_no" label="学员编号"> </el-table-column>
        <el-table-column prop="username" label="学员姓名"> </el-table-column>
        <el-table-column prop="mobile" label="注册手机号"> </el-table-column>
        <el-table-column prop="address" label="所属地区"> </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="导入失败记录" :visible.sync="dialogTableVisible">
      <el-table :data="errorArr">
        <!-- <el-table-column property="date" label="日期" width="150"></el-table-column> -->
        <el-table-column property="name" label="姓名" width="200"></el-table-column>
        <el-table-column property="msg" label="错误信息"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import areaSelect from "@/components/pub/areaSelectName.vue";
import { getStuList, delStudent, stuImport } from "@/api/student.js";
import { certificateList, exportStu } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
import { exportLearn } from "@/api/edu.js";
import { getSchoolList } from "@/api/school.js";

export default {
  components: {
    areaSelect,
  },
  mixins: [mixin],
  data() {
    return {
      searchParam: {
        keyword_search: "",
        schoole_uuid: "",
      },
      schooleList: [],
      cList: [],
      tableData: [],
      uping: false,
      dialogTableVisible: false,
      errorArr: [],
    };
  },
  mounted() {
    this.getList();
    this.getClist();
  },
  methods: {
    exportLearn() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
      };
      exportLearn(param);
    },
    clickInp() {
      document.getElementById("fileup").click();
    },
    getFile(e) {
      console.log(e.target.files[0]);
      const self = this;
      if (e && e.target.files) {
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        // console.log('sdf')
        this.uping = true;
        stuImport(fd)
          .then((res) => {
            console.log(res);
            self.uping = false;
            self.$message.success("上传成功【" + res.result + "】");
            console.log(res);
            if (res.errArr.length > 0) {
              self.errorArr = res.errArr;
              self.dialogTableVisible = true;
            }

            self.getList();
            // if (res instanceof Array) {
            //     this.selects.push(...res)
            // }
          })
          .catch((err) => {
            self.uping = false;
            self.$message.error("上传出错");
          });
      }
      // console.log(file)
    },
    resetSearchP() {
      this.searchParam = {};
      this.getList();
    },
    async getClist() {
      const res = await certificateList();
      this.loading = false;
      if (res.data instanceof Array) {
        this.cList = res.data;
      }
    },
    async getClist() {
      const res = await getSchoolList({ page_index: 1, page_size: 999, status: 1 });
      if (res.data instanceof Array) {
        this.schooleList = res.data;
      }
    },
    addStudent() {
      this.$router.push({ path: "/student-add" });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/student-detail", query: row });
    },
    async getList() {
      const res = await getStuList({
        ...this.searchParam,
        page_size: this.page_size,
        page_index: this.page_index,
      });
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      console.log(res);
    },
    async importStu() {
      const res = await stuImport({
        ...this.searchParam,
        page_size: this.page_size,
        page_index: this.page_index,
      });
      console.log(res, "导入");
      if (res.data instanceof Array) {
      }
      console.log(res);
    },
    exportStu() {
      const param = {
        ...this.searchParam,
        page_size: this.page_size,
        page_index: this.page_index,
      };
      exportStu(param);
    },
    deleteItem(row) {
      this.$confirm("确定要删除该学员吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delStudent(row.id).then((res) => {
            console.log(res);
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
          // this.userOption()
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
